<template>
  <div class="flex flex-col gap-10">
    <!-- Search and filters skeleton -->
    <div class="flex flex-row gap-4">
      <div class="grid grid-cols-4 gap-3 w-full lg:w-full">
        <div class="flex justify-center lg:justify-end w-full lg:w-full col-span-2">
          <div class="h-8 w-full lg:w-42 bg-gray-800 rounded-md animate-pulse" />
        </div>
        <div class="h-8 bg-gray-800 rounded-md animate-pulse col-span-1" />
        <div class="h-8 bg-gray-800 rounded-md animate-pulse col-span-1" />
      </div>
    </div>

    <!-- Multiple category sections skeleton -->
    <ContentRowSkeleton :count="4" />
    <ContentRowSkeleton :count="4" />
    <ContentRowSkeleton :count="4" />
    <ContentRowSkeleton :count="4" />
  </div>
</template>

<script setup>
import ContentRowSkeleton from './ContentRowSkeleton.vue';
</script>
